/* eslint-disable array-callback-return */
/* eslint-disable no-useless-concat */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TopTabBar from "../../components/app-bar";
import { pages } from "../../assets/data/all-data";
import { TicketCard } from "./ticket-card";
import { InfoCard } from "./info-card";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Skeleton,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { GET } from "../../config/https";
import { usePersistentState } from "../../contexts/global-context";
import APIS from "../../config/api";
import { toast } from "react-hot-toast";
import { useLocation, useParams } from "react-router-dom";
import { Parser } from "html-to-react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GetLocalStorage } from "../../utils/local-storage";

function srcset(image: string, size: number, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format&dpr=2 2x`,
  };
}

export const EventDetails = () => {
  const location: any = useLocation();
  const currentUrl = window.location.href;
  const regex = /\/event\/(.+)/;
  const match = currentUrl.match(regex);
  const eventId = match ? match[1] : null;
  //let id = location?.state?.eventId || eventId;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [state, dispatch]: any = usePersistentState();
  const [expanded, setExpanded] = useState<string | false>(false);
  const [event, setEvent] = useState<any>([]);


  const { eventName } = useParams();
   useEffect(() => {
    GetEvent();
    dispatch({ couponInfo: {} });
    let isPaymentSuccess = GetLocalStorage("isPaymentSuccess");
    if (isPaymentSuccess) {
      localStorage.setItem("CheckOutData", JSON.stringify({}));
      localStorage.setItem("CustomerInfo", JSON.stringify({}));
      localStorage.setItem("isPaymentSuccess", "false");
    }
    localStorage.setItem("CheckOutData", JSON.stringify({}));
    localStorage.setItem("CouponInfo", JSON.stringify({}));
    dispatch({ EventId: state?.Event?.id });
  }, []);


if (!eventName) {
  return <div>Event not found</div>; // or redirect
}

  let id = decodeURIComponent(eventName); // ICONIC-Countdown-2026
    //console.log("eventName param:", idx);

  //let retryCount = 0;
  const GetEvent = async () => {
    console.log("Fetching event with id:",id);
    await GET(APIS.GET_EVENT_BY_ID + "?" + "eventRoute=" + id)
      .then((res: any) => {
        if (res?.isSuccess) {
          console.log("EventVenue...............",res)
          dispatch({ Event: res.result });
          setEvent(res?.result);
          dispatch({ EventSecondId: res?.id });
          dispatch({ EventVenue: res.result?.eventVenue });
          dispatch({ EventSchedule: res.result?.eventSchedules });
          dispatch({ EventTicketConfig: res.result?.eventTicketConfigs });
          dispatch({ EventFaq: res.result?.eventFaqs });
        } else {
          console.log(toast.error(res?.errors[0]));
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
//  const GetEvent = async () => {
//   let retryCount = Number(localStorage.getItem("eventRetryCount") || 0);

//   try {
//     console.log("Fetching event with id:", id);

//     const res: any = await GET(APIS.GET_EVENT_BY_ID + "?eventRoute=" + id);

//     if (res?.isSuccess) {
//       console.log("EventVenue...............", res);

//       // Reset retry count because request was successful
//       localStorage.removeItem("eventRetryCount");

//       dispatch({ Event: res.result });
//       setEvent(res?.result);
//       dispatch({ EventSecondId: res?.id });
//       dispatch({ EventVenue: res.result?.eventVenue });
//       dispatch({ EventSchedule: res.result?.eventSchedules });
//       dispatch({ EventTicketConfig: res.result?.eventTicketConfigs });
//       dispatch({ EventFaq: res.result?.eventFaqs });

//     } else {
//       toast.error(res?.errors?.[0] || "Something went wrong");
//       handleRetry(retryCount);
//     }
//   } catch (error) {
//     console.log("error", error);
//     handleRetry(retryCount);
//   }
// };

// const handleRetry = (retryCount: number) => {
//   if (retryCount < 2) {
//     retryCount++;
//     localStorage.setItem("eventRetryCount", retryCount.toString());
//     console.log("Retrying... attempt:", retryCount);
//     window.location.reload();
//   } else {
//     console.log("Max retries reached");
//     // toast.error("Unable to load event. Please try again later.");

//     // Stop retry attempts
//     localStorage.removeItem("eventRetryCount");
//   }
// };

  const eventBanners = event?.eventBanners;
  const eventBanner = eventBanners?.filter(function (eventBanners: any) {
    if (eventBanners?.filePath && eventBanners?.isCoverdImage === true) {
      return true;
    }
  });
  const images = eventBanner?.map((x: any) => x.filePath);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div>
      <TopTabBar
        backgroundColors={"#2f3138"}
        textColor={"#fff"}
        iconColor={"#2f3138"}
        pages={pages}
        event={"events"}
      />
      <div
        id="events"
        style={{
          margin: "50px auto",
          maxWidth: "1520px",
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={9} md={8}>
            <div style={{ textAlign: "center" }}>
              {images ? (
                <img
                  src={images}
                  alt="Event"
                  style={{
                    borderRadius: "10px",
                    display: "block",
                    margin: "30px auto",
                    maxWidth: "100%",
                    height: "100%",
                    maxHeight: "515px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <div
                  style={{
                    padding: "20px",
                  }}
                >
                  <Skeleton
                    variant="rectangular"
                    style={{
                      maxWidth: "100%",
                      height: "400px",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              )}
            </div>
            <Grid container spacing={3} style={{ display: "flex" }}>
              <Grid item xs={12} sm={12} md={12}>
                <Card>
                  <CardContent>
                    {event?.title ? (
                      <Typography
                        variant="h4"
                        style={{ fontSize: "22px", color: "#333" }}
                      >
                        {event?.title}
                      </Typography>
                    ) : (
                      <Skeleton
                        animation="wave"
                        variant="text"
                        sx={{ fontSize: "1rem", width: "150px" }}
                      />
                    )}

                    {event?.description ? (
                      <Typography
                        style={{
                          fontSize: "15px",
                          color: "#666",
                          marginTop: "10px",
                          msWordBreak: "break-all",
                          wordBreak: "break-all",
                        }}
                      >
                        {Parser().parse(
                          event?.description ? event.description : ""
                        )}
                      </Typography>
                    ) : (
                      <>
                        <Skeleton
                          variant="text"
                          animation="wave"
                          sx={{ fontSize: "1rem" }}
                        />
                        <Skeleton
                          variant="text"
                          animation="wave"
                          sx={{ fontSize: "1rem" }}
                        />
                        <Skeleton
                          variant="text"
                          animation="wave"
                          sx={{ fontSize: "1rem" }}
                        />
                      </>
                    )}
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <ImageList
                  sx={{ width: "auto" }}
                  variant="masonry"
                  cols={isSmallScreen ? 2 : 4}
                  rowHeight={isSmallScreen ? "auto" : "auto"}
                >
                  {event?.eventBanners ? (
                    event?.eventBanners?.map((item: any, index: any) => (
                      <ImageListItem
                        key={index}
                        cols={item.cols || 1}
                        rows={item.rows || 1}
                      >
                        <img
                          {...srcset(item.filePath, 121, item.rows, item.cols)}
                          loading="lazy"
                        />
                      </ImageListItem>
                    ))
                  ) : (
                    <Skeleton variant="rectangular" width={210} height={560} />
                  )}
                </ImageList>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Card>
                  <CardContent>
                    <TicketCard />
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">FAQs</Typography>
                    {event?.eventFaqs?.length > 0 ? (
                      event?.eventFaqs?.length > 0 ? (
                        <div>
                          {event?.eventFaqs?.map((faq: any, index: any) => (
                            <Accordion
                              key={index}
                              expanded={expanded === `panel${index}`}
                              onChange={handleChange(`panel${index}`)}
                            >
                              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography
                                  style={{ color: "#666" }}
                                  variant="subtitle1"
                                >
                                  {faq?.title}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Typography>{faq?.description}</Typography>
                              </AccordionDetails>
                            </Accordion>
                          ))}
                        </div>
                      ) : (
                        <>
                          <Typography textAlign="center">
                            No Data found
                          </Typography>
                        </>
                      )
                    ) : (
                      <>
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "1rem", width: "450px" }}
                        />
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "1rem", width: "850px" }}
                        />
                      </>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
          <InfoCard />
        </Grid>
      </div>
    </div>
  );
};
